<!--  -->
<template>
  <div class="groupchat_box">
    <!-- <el-button style="margin-bottom:10px" type="primary" @click="groupchatcteat">群聊创建</el-button> -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="corpName"
        label="企业名称"
        align="center"
        width="150"
      />
      <el-table-column
        prop="name"
        label="群聊名称"
        width="150"
        align="center"
      />

      <el-table-column
        prop="userNum"
        label="人数"
        width="100"
        align="center"
      />

      <el-table-column
        prop="userNum"
        label="头像"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <img :src="scope.row.avatar" class="avatar_box" alt="">
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="official"
        label="绑定公众号"
        width="180"
      /> -->
      <!-- <el-table-column
        prop="official"
        label="成员"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <div class="member_box">
            <div v-for="item,indexr in scope.row.users.list.slice(0,3)" :key="indexr" class="member_item">{{ item.name }}</div>
            <el-button v-if="scope.row.users.hasMore" type="text" @click="more(scope.row.users.list)">更多</el-button>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="official"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="mini">删除</el-button> -->
          <!-- <el-button type="primary" size="mini" @click="groupmembers(scope.row)">查看群成员列表</el-button> -->
          <el-button type="primary" size="mini" @click="choosedaw(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="更多成员"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <moremembers ref="menberdom" />
    </el-dialog>
    <el-dialog
      title="群聊创建"
      :visible.sync="groupchatdialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <groupchatcteat ref="groupchatcteatdom" @createupdata="createupdata" />
    </el-dialog>

    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { groupchat } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import moremembers from './components/moremembers.vue'
// import groupchatcteat from './components/groupchatcteat.vue'
export default {
  components: {
    PaginationRight
    // moremembers,
    // groupchatcteat
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10
      },
      total: null,
      tableData: [],
      dialogVisible: false,
      groupchatdialogVisible: false
    }
  },
  created() {
    // this.groupchatlist()
  },
  mounted() {

  },
  methods: {
    send() {
      this.groupchatlist()
    },
    async groupchatlist() {
      const data = await groupchat(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.groupchatlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.groupchatlist()
    },
    // more(item) {
    //   console.log('item', item)
    //   this.dialogVisible = true
    //   this.$nextTick(() => {
    //     this.$refs.menberdom.send(item)
    //   })
    // },
    groupmembers(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.menberdom.send(item)
      })
    },
    groupchatcteat() {
      this.groupchatdialogVisible = true
      this.$nextTick(() => {
        this.$refs.groupchatcteatdom.send()
      })
    },
    createupdata() {
      this.groupchatdialogVisible = false
      this.groupchatlist()
    },
    choosedaw(item) {
      this.$emit('callabck', item)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.groupchat_box{
  padding: 20px;
}
.member_box{
  display: flex;
  align-items: center;
}
.member_item{
  margin-right: 10px;
}
.avatar_box{
  width: 50px;
  height: 50px;
}
</style>
